//função que valida se a empresa teve o seu orçamento como vencedor para a O.S
//passada por parâmetro
export function isWinner(ordemServico, idEmpresa) {
  return ordemServico.ordensServicosOrcamentos?.some(orcamento => orcamento.idEmpresa == idEmpresa && orcamento.statusOrcamento === 1);
}
